(function () {
  var el = document.getElementById('hestia-urgency-timer');
  if (!el) return;
  // Fresh countdown on every page visit (no localStorage persistence)
  var duration = parseInt(el.getAttribute('data-duration-ms'), 10) || 4763000;
  var end = Date.now() + duration;
  var hEl = el.querySelector('[data-h]');
  var mEl = el.querySelector('[data-m]');
  var sEl = el.querySelector('[data-s]');
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var left = Math.max(0, end - Date.now());
    if (left <= 0) {
      el.classList.add('is-expired');
      if (hEl) hEl.textContent = '00';
      if (mEl) mEl.textContent = '00';
      if (sEl) sEl.textContent = '00';
      return;
    }
    var totalSec = Math.floor(left / 1000);
    var h = Math.floor(totalSec / 3600);
    var m = Math.floor((totalSec % 3600) / 60);
    var s = totalSec % 60;
    if (hEl) hEl.textContent = pad(h);
    if (mEl) mEl.textContent = pad(m);
    if (sEl) sEl.textContent = pad(s);
    requestAnimationFrame(function () { setTimeout(tick, 250); });
  }
  // Clear any old persisted deadline from prior versions
  try { localStorage.removeItem('hestia:urgency-deadline-v1'); } catch (e) {}
  tick();
})();
